import React, { useEffect, useState } from "react";
import "./GlobalSecondTable.scss";
import { useLoading } from "../../LoadingContext"; // ✅ ADD THIS

export const GlobalSecondTable = ({
  data,
  columns,
  selectedRows,
  onCheckboxChange,
  onRowClick,
  disableSelection, 
    isLoading, // ✅ ADD THIS - prop to control loader

}) => {

const { setLoading } = useLoading(); // ✅ ADD THIS - Global loader
  const [isTableLoading, setIsTableLoading] = useState(false);

  // ✅ ADD THIS - Handle loading state
  useEffect(() => {
    if (isLoading !== undefined) {
      setLoading(isLoading);
      setIsTableLoading(isLoading);
    }
  }, [isLoading, setLoading]);

  
  const filteredColumns = disableSelection
    ? columns.filter((column) => column.accessor !== "select")
    : columns;

  
   // ✅ ADD THIS - Show loader in table
  if (isTableLoading || isLoading) {
    return (
      <div className="table-loader-container">
        <div className="table-loader">
          <div className="loader-spinner"></div>
          <p>Loading data...</p>
        </div>
      </div>
    );
  }

  // ✅ ADD THIS - Show empty state
  if (!data || data.length === 0) {
    return (
      <div className="table-empty-container">
        <p>No data available</p>
      </div>
    );
  }
  return (
    <table>
      <thead>
        <tr>
          {!disableSelection && (
            <th>
              <div className="global_col">
                <span>Select</span>
              </div>
            </th>
          )}
          {filteredColumns.map((col, idx) => (
            <th key={idx} className="table_col">
              <div className="global_col">
                <span>{col.label}</span> 
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, idx) => (
          <tr key={idx} onClick={() => onRowClick && onRowClick(row)}>
            {!disableSelection && (
              <td>
                <input
                  type="checkbox"
                  name={row.rowId} 
                  checked={selectedRows.includes(row.rowId)} 
                  onChange={(e) => onCheckboxChange(row.rowId, e.target.checked)} 
                />
              </td>
            )}

            {filteredColumns.map((col, colIdx) => (
              <td key={colIdx}>{row[col.accessor]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};


